
























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import BarChart from '@/components/BarChart.vue'
import { Api } from '@/fetch/Api'
import type { AnalyticsViews, AnalyticsMetrics } from '@/interfaces'
import moment, { Moment } from 'moment'
import store from '@/store'

@Component({
  components: {
    BarChart,
    PageHead,
  },
})
export default class VisitorActivity extends Vue {
  pageTitle = 'Visitor Activity'
  callInProgress = false
  pageviewsChartData: Chart.ChartData = null
  sessions: AnalyticsViews[] = null
  urlMetrics: AnalyticsMetrics[] = null
  deviceMetrics: AnalyticsMetrics[] = null
  urlFilter: string = null
  showHelpGuide = false
  dateRange = 'today'
  dateTo: Moment = moment()
  dateRangeFilters = {
    today: {
      dateFrom: moment().startOf('day'),
      unit: 'hour',
    },
    last24hours: {
      dateFrom: moment().subtract(24, 'hours').startOf('hour'),
      unit: 'hour',
    },
    thisweek: {
      dateFrom: moment().startOf('week'),
      unit: 'day',
    },
    last7days: {
      dateFrom: moment().subtract(6, 'days').startOf('day'),
      unit: 'day',
    },
    thismonth: {
      dateFrom: moment().startOf('month').startOf('day'),
      unit: 'day',
    },
    last30days: {
      dateFrom: moment().subtract(30, 'days').startOf('day'),
      unit: 'day',
    },
    last3months: {
      dateFrom: moment().subtract(2, 'months').startOf('month').startOf('day'),
      unit: 'month',
    },
    thisyear: {
      dateFrom: moment().startOf('year').startOf('day'),
      unit: 'month',
    },
  }

  public chartOptions: Chart.ChartOptions = {
    legend: {
      display: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          id: 'y-axis-1',
          type: 'linear',
          display: true,
          position: 'left',
          ticks: {
            beginAtZero: true,
            stepSize: 1,
          },
        },
      ],
    },
  }

  mounted() {
    this.fetchAnalytics()
    this.showHelpGuidePopUp()
  }

  filterByUrl(url) {
    this.urlFilter = url
  }

  disableUrlFilter() {
    this.urlFilter = null
  }

  @Watch('urlFilter')
  onVariable() {
    this.fetchAnalytics()
  }

  public async fetchAnalytics() {
    this.callInProgress = true
    try {
      console.log(this.dateRangeFilters[this.dateRange])
      const response = await Api.getAnalyticsData(
        this.dateRangeFilters[this.dateRange].dateFrom.valueOf(),
        this.dateTo.valueOf(),
        this.dateRangeFilters[this.dateRange].unit,
        this.urlFilter,
      )
      console.log(this.dateRangeFilters[this.dateRange])
      this.pageviewsChartData = response.pageviews
      this.sessions = response.sessions
      this.urlMetrics = response.urlMetrics
      this.deviceMetrics = response.deviceMetrics
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public showHelpGuidePopUp() {
    if (store.getters.showVisitorHelpGuide) {
      this.$bvModal.show('modal-help-guide')
    }
  }

  public toggleHelpGuideDisplayChoice() {
    store.commit('toggleFlag', 'showVisitorHelpGuide')
  }
}

